import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { IconArrow, rem } from 'design-system';
import { IconRocket } from 'design-system/icons/IconRocket';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { formatExpiryDate } from 'features/invest/utils';
import { getPausedUntilLabel } from 'features/invest/utils/autoinvest';
import { selectAutosaveStatusObj } from 'reducers/selectors';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
import AutosaveStatus from './AutosaveStatus';
const AutosaveEntryCard = () => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const autoSaveId = useAppSelector((state) => state.pots.savingsPlan?.id);
    const pausedUntil = useAppSelector((state) => state.pots.savingsPlan?.pausedUntil);
    const autosaveStatusObject = useAppSelector(selectAutosaveStatusObj);
    const nextPaymentCollectionDate = useAppSelector((state) => state.pots.savingsPlan?.nextPaymentCollectionDate);
    const onPress = useCallback(() => {
        navigation.navigate('AutoSave');
    }, []);
    const handleOpenAutosave = useCallback(() => {
        if (showUnavailableOnWeb('emma://auto-save', 'Set up Autosave')) {
            return;
        }
        navigation.navigate('AutosaveIntro');
    }, []);
    const description = useMemo(() => {
        if (!autosaveStatusObject || autosaveStatusObject?.actionRequired || autosaveStatusObject.isPending)
            return null;
        if (autosaveStatusObject?.isPaused) {
            if (pausedUntil) {
                return (<Text TextThin-14 Secondary>
            {getPausedUntilLabel(pausedUntil)}
          </Text>);
            }
        }
        else if (nextPaymentCollectionDate) {
            return (<Text TextThin-14 Secondary>
          Next {formatExpiryDate(nextPaymentCollectionDate, 'save')}
        </Text>);
        }
        return null;
    }, [autosaveStatusObject, nextPaymentCollectionDate, pausedUntil]);
    if (!autoSaveId) {
        return (<TouchableBounceCard onDark onPress={handleOpenAutosave} noMarginBottom noMarginTop style={styles.button}>
        <View style={styles.container}>
          <Squircle color={colors.background.dark}>
            <IconRocket colorKey="brand"/>
          </Squircle>
          <View style={styles.flex}>
            <Text Text-16>Autosave</Text>
            <Text TextThin-14 Secondary>
              Save 10x more, without thinking about it
            </Text>
          </View>
          <IconArrow direction="right"/>
        </View>
      </TouchableBounceCard>);
    }
    return (<TouchableBounceCard onDark onPress={onPress} noMarginBottom noMarginTop style={styles.button}>
      <View style={styles.container}>
        <Squircle color={colors.background.dark}>
          <IconRocket colorKey="brand"/>
        </Squircle>
        <View style={styles.flex}>
          <AutosaveStatus />
          <Text Text-16>Autosave</Text>
          {description}
        </View>
        <IconArrow direction="right"/>
      </View>
    </TouchableBounceCard>);
};
export default AutosaveEntryCard;
const styles = StyleSheet.create({
    button: {
        marginTop: rem(8),
        marginBottom: rem(8),
    },
    container: {
        gap: rem(16),
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
});
